// extracted by mini-css-extract-plugin
export default {"chartBox":"Chart_chartBox__WutY-","empty":"Chart_empty__e3RFg"};